import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, Mail, MapPin, Heart } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_tmb-foundation/artifacts/v9zjv1mj_TMB%20Logo.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A2421] text-[#FAF8F5] mt-24">
      <div className="container-tmb px-6 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <img
              src={LOGO_URL}
              alt="TMB Global Foundation"
              className="w-14 h-14 object-contain"
            />
            <div>
              <div className="font-display text-2xl">TMB Global</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#D99A29] font-bold">
                Foundation
              </div>
            </div>
          </div>
          <p className="text-[#FAF8F5]/75 max-w-md leading-relaxed">
            TMB Global Foundation is a mission-driven organization expanding access to
            healthcare, energy, food systems, education, and digital infrastructure for
            underserved communities worldwide.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="https://facebook.com" target="_blank" rel="noreferrer" data-testid="social-facebook" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#C85A3A] flex items-center justify-center transition-all">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="social-instagram" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#C85A3A] flex items-center justify-center transition-all">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" data-testid="social-twitter" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#C85A3A] flex items-center justify-center transition-all">
              <Twitter className="w-4 h-4" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" data-testid="social-youtube" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#C85A3A] flex items-center justify-center transition-all">
              <Youtube className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-[#D99A29] uppercase text-xs tracking-[0.22em] font-bold mb-5">
            Navigate
          </div>
          <ul className="space-y-3 text-[#FAF8F5]/80">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/vision" className="hover:text-white">Our Vision</Link></li>
            <li><Link to="/mission" className="hover:text-white">Our Mission</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            <li><Link to="/donate" className="hover:text-white">Donate</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[#D99A29] uppercase text-xs tracking-[0.22em] font-bold mb-5">
            Our Offices
          </div>
          <ul className="space-y-5 text-[#FAF8F5]/85 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#D99A29] shrink-0" />
              <div>
                <div className="font-semibold text-white mb-0.5">Detroit, USA</div>
                TMB Global Network<br />
                2722 Second Street, Ste. G-2<br />
                Detroit, MI 48201
              </div>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#D99A29] shrink-0" />
              <div>
                <div className="font-semibold text-white mb-0.5">Johannesburg, ZA</div>
                155 West Street<br />
                Sandton, Johannesburg<br />
                Gauteng 2126
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-1 text-[#D99A29] shrink-0" />
              <a href="mailto:info@tmbglobal.news" className="hover:text-white">info@tmbglobal.news</a>
            </li>
          </ul>
          <Link to="/donate" data-testid="footer-donate-cta" className="btn-primary mt-6">
            <Heart className="w-4 h-4" /> Support Our Mission
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-tmb px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/60">
          <div>© {new Date().getFullYear()} TMB Global Foundation. All rights reserved.</div>
          <div>Building resilient communities through innovation, access and global collaboration.</div>
        </div>
      </div>
    </footer>
  );
}
